import { render, staticRenderFns } from "./feedSubmit.vue?vue&type=template&id=5527968e"
import script from "./feedSubmit.vue?vue&type=script&lang=js"
export * from "./feedSubmit.vue?vue&type=script&lang=js"
import style0 from "./feedSubmit.vue?vue&type=style&index=0&id=5527968e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports